import { HttpClient } from '#client/http/index'
import {
  TimetableListParams,
  ListTimetableItem,
  TimetableId,
} from '#client/resources/index'
import { ApiResponse, PagerMeta } from '#client/resources/types'
import { depend } from '#client/utils/depend'
import snakecaseKeys from 'snakecase-keys'

export const list = depend(
  { transformParams: snakecaseKeys },
  async (
    { transformParams },
    { httpClient }: { httpClient: HttpClient },
    params: TimetableListParams,
  ) => {
    const { data, meta }: ApiResponse<ListTimetableItem[], PagerMeta> =
      await httpClient.get(`/user/timetables`, {
        params: transformParams({
          ...params,
          showFullReservations: params.showFullReservations ? 1 : 0,
          isOnline: params.isOnline ? 1 : 0,
        }),
      })
    return { data, meta }
  },
)

export const isReservable = async (
  { httpClient }: { httpClient: HttpClient },
  id: TimetableId,
) => {
  return await httpClient.get(`/user/timetables/isReservable/${id}`)
}
